// extracted by mini-css-extract-plugin
export default {"wrapper":"Quantity_wrapper__xyXPj","quantity":"Quantity_quantity__pRR7N","value":"Quantity_value__l152w"};